export default "__VITE_ASSET__Cl6TOcaB__"